import gift from "public/gift.png";
import { BenefitsCard2 } from "../components/WACardWrappers";
import logo from "public/getchat-logo.png";

const OfferComponent: React.FC = () => {
    return (
        <div className=" bg-green-500">
            <div className="py-10 max-w-6xl mx-auto">
                <div className="lg:text-4xl text-3xl font-semibold mx-auto text-white w-full text-center px-2 pb-4">
                    Our exclusive migration offer for
                    <img className="w-14 h-14 inline-block ml-2 mr-2" src={logo} alt="Logo"></img>
                    <span className="text-green-800"> get.chat </span>
                    users
                </div>
                <div className="lg:text-3xl text-2xl font-semibold mx-auto text-white w-full text-center px-2 pb-10">(Choose any one)</div>

                <div className="max-w-6xl w-full mx-auto flex flex-col gap-6">
                    <div className="flex gap-3 flex-col lg:flex-row px-5 md:px-10 lg:px-0 pt-10 lg:space-y-0 space-y-10">
                        <BenefitsCard2>
                            <div className=" rounded-xl" style={{ position: "relative" }}>
                                <h3 className="text-2xl  m-0">🌟 Unlock 30% OFF All Plans! </h3>
                            </div>
                        </BenefitsCard2>
                        <BenefitsCard2>
                            <div style={{ position: "relative" }}>
                                <img alt="Grow your brand salience" className=" h-20 w-20" src={gift} style={{ position: "absolute", top: "-5rem", right: "6rem" }} />
                                <h3 className="text-2xl m-0">🎁 Yearly Deal: Pay 8, Enjoy 12! 4 Months FREE!</h3>
                            </div>
                        </BenefitsCard2>

                        <BenefitsCard2>
                            <div style={{ position: "relative" }}>
                                <h3 className="text-2xl m-0">🔄 Flexibility, Doubled! Choose 3 Months, Get 6! </h3>
                            </div>
                        </BenefitsCard2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfferComponent;
